var _path, _path2, _path3;
const _excluded = ["title", "titleId"];
function _extends() { return _extends = Object.assign ? Object.assign.bind() : function (n) { for (var e = 1; e < arguments.length; e++) { var t = arguments[e]; for (var r in t) ({}).hasOwnProperty.call(t, r) && (n[r] = t[r]); } return n; }, _extends.apply(null, arguments); }
function _objectWithoutProperties(e, t) { if (null == e) return {}; var o, r, i = _objectWithoutPropertiesLoose(e, t); if (Object.getOwnPropertySymbols) { var s = Object.getOwnPropertySymbols(e); for (r = 0; r < s.length; r++) o = s[r], t.includes(o) || {}.propertyIsEnumerable.call(e, o) && (i[o] = e[o]); } return i; }
function _objectWithoutPropertiesLoose(r, e) { if (null == r) return {}; var t = {}; for (var n in r) if ({}.hasOwnProperty.call(r, n)) { if (e.includes(n)) continue; t[n] = r[n]; } return t; }
import * as React from "react";
function SvgDotsVerticalLarge(_ref, svgRef) {
  let {
      title,
      titleId
    } = _ref,
    props = _objectWithoutProperties(_ref, _excluded);
  return /*#__PURE__*/React.createElement("svg", _extends({
    width: 56,
    height: 57,
    viewBox: "0 0 56 57",
    fill: "none",
    xmlns: "http://www.w3.org/2000/svg",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _path || (_path = /*#__PURE__*/React.createElement("path", {
    d: "M28.0013 30.833C29.29 30.833 30.3346 29.7883 30.3346 28.4997C30.3346 27.211 29.29 26.1663 28.0013 26.1663C26.7126 26.1663 25.668 27.211 25.668 28.4997C25.668 29.7883 26.7126 30.833 28.0013 30.833Z",
    stroke: "#6366F1",
    strokeWidth: 4,
    strokeLinecap: "round",
    strokeLinejoin: "round"
  })), _path2 || (_path2 = /*#__PURE__*/React.createElement("path", {
    d: "M28.0013 14.4997C29.29 14.4997 30.3346 13.455 30.3346 12.1663C30.3346 10.8777 29.29 9.83301 28.0013 9.83301C26.7126 9.83301 25.668 10.8777 25.668 12.1663C25.668 13.455 26.7126 14.4997 28.0013 14.4997Z",
    stroke: "#6366F1",
    strokeWidth: 4,
    strokeLinecap: "round",
    strokeLinejoin: "round"
  })), _path3 || (_path3 = /*#__PURE__*/React.createElement("path", {
    d: "M28.0013 47.1663C29.29 47.1663 30.3346 46.1217 30.3346 44.833C30.3346 43.5443 29.29 42.4997 28.0013 42.4997C26.7126 42.4997 25.668 43.5443 25.668 44.833C25.668 46.1217 26.7126 47.1663 28.0013 47.1663Z",
    stroke: "#6366F1",
    strokeWidth: 4,
    strokeLinecap: "round",
    strokeLinejoin: "round"
  })));
}
const ForwardRef = /*#__PURE__*/React.forwardRef(SvgDotsVerticalLarge);
export default __webpack_public_path__ + "static/media/dots-vertical_large.c337e6112ad7bc8fc027a2615f855399.svg";
export { ForwardRef as ReactComponent };